export enum UserAnalyticsTrackerType {
    FIRST_ELEMENT_CREATION = 'firstElementCreation',
    THIRD_ELEMENT_CREATION = 'thirdElementCreation',
    FIRST_IMAGE_CREATION = 'firstImageCreation',
}

export type MNUserAnalyticsTrackerState = {
    elementCreationCount?: number;
};

export type PendingEvent = {
    eventProperties?: Record<string, unknown>;
    userProperties?: Record<string, unknown>;
};

export type MNUserAnalyticsDocument = {
    userId: string;
    trackerType: UserAnalyticsTrackerType;
    createdAt: number;
    expiresAt: Date;
    updatedAt: number;
    state?: MNUserAnalyticsTrackerState;
    pendingEvent?: PendingEvent;
    _id?: string;
    __v?: number;
};

export type MNUserAnalyticsTracker = Omit<MNUserAnalyticsDocument, 'expiresAt'>;

export type MNUserAnalytics = Partial<Record<UserAnalyticsTrackerType, MNUserAnalyticsTracker>>;
